module.exports = "https://cdn.landi.com/assets/peilian/offical_website_pc/1.0.41/images/bcc0547717d29dfbc9ce727f849d0b48.png";